import { Navigate } from 'react-router-dom'

import { CanSeeBlackFridayPromoDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import RedirectToProductUpdatesPage from 'modules/discover/pages/RedirectToProductUpdates'

const DiscoverGuardPage = () => {
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()
  const { data, loading } = useQuery(CanSeeBlackFridayPromoDocument)
  const canSeePromo =
    data?.upsell._policies.canSeeBlackFridayPromo.can && !company.subscription?.inFreeTrial

  if (loading) {
    return <Loading />
  }

  return canSeePromo ? (
    <Navigate to={navigation.discover.marketplaceModules.fullPath()} replace />
  ) : (
    <RedirectToProductUpdatesPage />
  )
}

export default DiscoverGuardPage
